import React, { Component } from 'react';
import ReactDOM from "react-dom"

import "./Mentor.Popup.scss"
import closeBTN from "../../../../assets/images/utils/x_but.png"

class mPopup extends Component {
  constructor(props) {
    super();
    this.state = {
      offsetPop: 0
    }
  }
  componentDidMount() {
    var rect = ReactDOM.findDOMNode(this).getBoundingClientRect();
    this.popupOffset(rect);
  }
  popupOffset(val) {
    this.setState({
      offsetPop: {
        x: val.x,
        y: val.y,
        width: val.width,
        height: val.height,
        top: val.top
      }
    });
  }
  render() {
    const showBox = {
      display: (this.props.data.isActive === true ? "block" : "none")
    }
    const closeImage = {
      backgroundImage: "url(" + closeBTN + ")"
    }
    const fixPop = {
      /*
    <img src={(window.screen.width >= 640 ? this.props.data.large_imageURL : this.props.data.imageURL)} title="" alt="" />
      */
      //top: Math.round(this.state.offsetPop.top) + "px",
      //transform: "translate(-50%, " + Math.round(this.state.offsetPop.top) + "px)"
    }
    const proFileImage = {
      backgroundImage: "url(" + (window.screen.width >= 640 ? this.props.data.large_imageURL : this.props.data.imageURL) + ")"
    }
    return (
      <div>
        <div id="fadebox" onClick={this.props.onPopupClose} style={showBox}></div>
        <div id="popup" style={Object.assign({}, showBox, fixPop)}>
          <div className="padding">
            <div onClick={this.props.onPopupClose} style={closeImage} className="close"></div>
            <div className="message">
            <div className="imageBlock" style={proFileImage}>
              </div>
              <div className="popup-bio">
                <div className="popup-bio-padding">
                  <div className="popup-bio-name">
                    {this.props.data.name}
                  </div>
                  <div className="popup-bio-title">
                    {this.props.data.title}
                  </div>
                  <div className="popup-bio-line"></div>
                  <div className="popup-bio-desc">
                    {this.props.data.story}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default mPopup;



// WEBPACK FOOTER //
// ./src/components/Mentors/components/Mentor-Popup/Mentor.Popup.js